import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const COMPLAINT_CATEGORIES = ["Billing & charges", "Vehicle condition", "Delivery & pickup", "Customer service", "Damage dispute", "Other"];

export const NewComplaintDialog = ({ open, setOpen, form, setForm, bookings, busy, onSubmit }) => (
  <Dialog open={open} onOpenChange={setOpen}>
    <DialogContent data-testid="complaint-dialog">
      <DialogHeader>
        <DialogTitle className="heading-upper text-[#144733]">Raise a complaint</DialogTitle>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="field-label">Booking *</label>
          <select className="field-input" value={form.booking_ref} onChange={(e) => setForm({ ...form, booking_ref: e.target.value })} data-testid="complaint-booking-select">
            {bookings.map((b) => <option key={b.booking_ref} value={b.booking_ref}>{b.booking_ref} · {b.vehicle.name}</option>)}
          </select>
        </div>
        <div>
          <label className="field-label">Category *</label>
          <select className="field-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="complaint-category-select">
            {COMPLAINT_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="field-label">Subject *</label>
          <input required className="field-input" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="complaint-subject-input" />
        </div>
        <div>
          <label className="field-label">Tell us what happened *</label>
          <textarea required rows={4} className="field-input" value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="complaint-description-input" />
        </div>
        <button type="submit" disabled={busy} className="btn-cta rounded w-full py-3 text-xs" data-testid="complaint-submit-btn">
          {busy ? "Submitting…" : "Submit complaint"}
        </button>
      </form>
    </DialogContent>
  </Dialog>
);
